import {
	ChartData,
	Chart as ChartJS,
	ChartOptions,
	LineElement,
	LinearScale,
	Plugin,
	PointElement,
	Tooltip,
} from "chart.js";
import React, { MutableRefObject, forwardRef } from "react";
import { Scatter } from "react-chartjs-2";

import { AnyObject } from "chart.js/dist/types/basic";

import { axisLabels, getAvatarScatterPointFn } from "./utils";

import { avatarCache } from "../../shared/avatarCache";
import css from "../CreateExternalTooltip/ExternalTooltip.module.scss";

ChartJS.register(LinearScale, PointElement, LineElement, Tooltip);

export interface ScatterChartProps {
	data: ChartData<"scatter">;
	options: ChartOptions<"scatter">;
	plugins?: Plugin<"scatter", AnyObject>[];
	dataTestId?: string;
}

// all we're doing is exporting a configured Scatter chart
const ScatterChart = forwardRef(function ScatterChart(props: ScatterChartProps, ref) {
	const avatarScatterPoints = getAvatarScatterPointFn(avatarCache);
	return (
		<div className={css.scatterChart} data-testid={props.dataTestId}>
			<Scatter
				ref={ref as MutableRefObject<ChartJS<"scatter", any, unknown>>}
				data={props.data}
				options={props.options}
				plugins={[...(props.plugins || []), axisLabels, avatarScatterPoints]}
			/>
		</div>
	);
});

export default ScatterChart;
